import React, { useEffect, useState, useContext } from "react";
import { useHistory, generatePath } from "react-router-dom";
import { makeStyles, Typography, Card, CardHeader, CardContent, CardActions, IconButton, Box, Divider, Tooltip, Button } from "@material-ui/core";
import EqualizerIcon from '@material-ui/icons/Equalizer';
import LazyImageLoader from "../commonComponents/LazyImageLoader";
import AppConstants from "../../../common/AppConstants";
import Helper from "../../../common/Helper";
import RouteConstants from "../../../common/RouteConstants";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

const useStyles = makeStyles((theme) => ({
    cardbox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        border: '1px solid #b3b3b3',
        boxShadow: '0px 0px 1px 0px #b3b3b3',
        '& .MuiCardHeader-root': {
            padding: theme.spacing(.5, 1, 0),
            '& .MuiCardHeader-action': {
                marginTop: '0',
                marginRight: '0',
            },
        },
        '& .MuiCardContent-root': {
            padding: theme.spacing(0, 1, .75) + "!important",
            // height: '100%',
        },
        '& .MuiCardActions-root': {
            justifyContent: 'flex-end',
            '& .MuiButton-root': {
                background: '#000',
                color: '#fff',
                textTransform: 'unset',
                borderRadius: '50px',
                '& .MuiButton-label': {
                    '& .MuiSvgIcon-root': {
                        color: '#fff',
                    },
                },
            },
        },
    },
    cardFooterText: {
        fontSize: '0.65rem',
        lineHeight: '1',
        fontWeight: '500',
    },
    iconFontSize: {
        fontSize: '1rem',
    },
    badgeContainer: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
    },
    avatarSize: {
        display: 'inline-flex', width: '24px', height: '24px', marginRight: '4px'
    },
    title: {
        fontWeight: '500',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
}));

const PublicCurriculumCard = ({ option, handleCurriculumStart }) => {
    const classes = useStyles()
    const history = useHistory();

    const handleOnClick = () => {
        if (option && option.curriculumID) {
            history.push({
                pathname: generatePath(RouteConstants.CURRICULUM_CONTENT, { id: option.curriculumID }),
                state: {
                    isPublic: true,
                }
            });
        }
    }

    return (

        <Card variant="outlined" className={classes.cardbox}>
            <CardHeader
                action={
                    <>
                    </>
                }
                title={
                    <div className={classes.badgeContainer}>
                        <LazyImageLoader
                            id={"loader" + option.id}
                            key={"loader" + option.id}
                            showAvatar="true"
                            documentName={option && (option?.smallIconName || option?.mediumIconName)}
                            documentType="image"
                            className={classes.avatarSize}
                            onClick={() => { return false; }}
                        ></LazyImageLoader>
                        <Typography variant="subtitle2" style={{ color: ((option && option.badgeColor) ?? AppConstants.CURRICULUM_BADGE_DEFAULT_COLOR) }}>{option?.badgeName}</Typography>

                    </div>
                }
            />
            <CardContent>
                <Box display="flex" flexDirection="column">
                    <Tooltip title={option.curriculumName}>
                        <Typography variant="subtitle2" className={classes.title} component="div">
                            {option.curriculumName}
                        </Typography>
                    </Tooltip>
                    <Box component="div">

                        <Button variant="contained" endIcon={<PlayArrowIcon />} size='small' color="secondary" onClick={handleOnClick}>
                            Start
                        </Button>

                    </Box>
                </Box>
            </CardContent>
            <CardActions>
                <Box display="flex" alignItems="center" flex="1" justifyContent="space-between" style={{ display: 'flex', alignItems: 'center', flex: '1', justifyContent: 'space-between', }}>
                    <Box display="flex" alignItems="flex-start" justifyContent="space-between" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                        <Box marginRight={1} style={{ marginRight: '8px' }}>
                            <EqualizerIcon className={`${classes.iconFontSize}`} />
                        </Box>
                        <Box display="flex" flexDirection="column" style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="caption" className={`${classes.cardFooterText} `}>Curriculum Level</Typography>
                            <Typography variant="subtitle2" style={{ color: ((option && option.curriculumLevelColor) ?? AppConstants.CURRICULUM_LEVEL_DEFAULT_COLOR) }} >{option.curriculumLevelName}</Typography>
                        </Box>
                    </Box>
                    {!Helper.IfDateIsNULL(option.startTime) && option.isComplete == false ? <Box display="flex" flexDirection='column'>
                        <Typography variant="caption" className={`${classes.cardFooterText} `}>Started On:</Typography>
                        <Typography variant="subtitle2" >{Helper.FormatDateDDMMMYYYY(option.startTime)}</Typography>
                    </Box>
                        :
                        !Helper.IfDateIsNULL(option.endTime) && option.isComplete == true && <Box display="flex" flexDirection='column'>
                            <Typography variant="caption" className={`${classes.cardFooterText} `}>Completed On:</Typography>
                            <Typography variant="subtitle2" >{Helper.FormatDateDDMMMYYYY(option.endTime)}</Typography>
                        </Box>}

                </Box>
            </CardActions>
        </Card>
    )
}

export default PublicCurriculumCard